import { type ReactNode } from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

type EmbeddedLayoutProps = {
  children: ReactNode;
  /** Sticky footer rendered outside the scroll area */
  footer?: ReactNode;
};

/**
 * EmbeddedLayout — Minimal page shell for iframe-embedded Ronan.
 *
 * No sidebar, no top bar, no language selector, no branding footer.
 * Just the content in a scrollable area with an optional sticky footer.
 */
export default function EmbeddedLayout({
  children,
  footer,
}: EmbeddedLayoutProps) {
  return (
    <div className="flex flex-col h-dvh w-full font-inter bg-background">
      <main className="flex flex-1 flex-col items-center overflow-y-auto px-4 min-h-0">
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>

      {footer && (
        <div className="shrink-0 border-t border-border bg-background px-4 pt-4 pb-2">
          {footer}
        </div>
      )}
    </div>
  );
}
